// extracted by mini-css-extract-plugin
export default {"unitSlot":"unit-slot_unitSlot__1nNCa","content":"unit-slot_content__6ve47","unit-arrive":"unit-slot_unit-arrive__XKXN1"};